module.exports = __webpack_public_path__ + "static/media/cafe_europa_f_thumb_even.606313d3.webp";